import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sat Sep 10 2018
 * @author LZe
 */
import * as React from 'react';
import SelectValidated from '../../../../inputs/Select';
import CellEditor from './CellEditor';
import { Key } from '../../../../../shared/keyboard/Key';
import { when } from 'mobx';
/**
 * Select editor (multiple choices) for the AgGrid
 * @extends CellEditor
 */

var SelectEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(SelectEditor, _CellEditor);

  function SelectEditor(props) {
    var _this;

    _classCallCheck(this, SelectEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectEditor).call(this, props));
    _this.moveDown = false;
    /**
     * Handles changes of the select element
     */

    _this.onChange = function (value) {
      // PROMO-47
      if (value !== undefined) {
        _this.updateValue(value);
      }
    }; // LOG-2685 - To use select box in the popup mode uncomment these two methods and update AgGrid to the 20.2.0


    _this.isPopup = function () {
      return true;
    };

    _this.handleNavigation = function (e) {
      if (e.key === Key.Enter && !_this.props.context.store.invalid) {
        _this.moveDown = true;
      }
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(SelectValidated, {
        options: _this.options,
        value: _this.state.value,
        onChange: _this.onChange,
        style: {
          minWidth: _this.props.eGridCell.offsetWidth
        },
        openOnFocus: true,
        tiny: true,
        validationError: _this.state.validationError
      }));
    }; // LOG-3758


    when(function () {
      return _this.updatingDone;
    }, function () {
      return _this.setFocusAndEditingToNextCell();
    });
    return _this;
  }

  _createClass(SelectEditor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Stops editing if the value is selected
      if (this.state.value !== prevState.value && !this.props.context.store.invalid && !this.state.validationError) {
        this.props.stopEditing();
      } else {
        // move to next row
        this.props.stopEditing();
        this.setUpdatingDone();
      }
    } // LOG-3758

  }, {
    key: "setFocusAndEditingToNextCell",
    value: function setFocusAndEditingToNextCell() {
      this.setUpdatingDoneDefault();
      this.props.api.clearRangeSelection();

      if (this.props.node.rowPinned !== 'top') {
        if (this.moveDown) {
          this.props.api.setFocusedCell(this.props.rowIndex + 1, this.props.column.getId());
          this.props.api.startEditingCell({
            rowIndex: this.props.rowIndex + 1,
            colKey: this.props.column.getId()
          });
        }

        if (this.props.api.getModel().getPageLastRow() === this.props.rowIndex) {
          this.props.api.setFocusedCell(this.props.rowIndex, this.props.column.getId());
        }
      } else {
        this.props.api.setFocusedCell(this.props.rowIndex, this.props.column.getId(), 'top');
      }
    }
  }, {
    key: "options",
    get: function get() {
      if (this.colDef.selectOptionsGenerator) {
        return this.colDef.selectOptionsGenerator(this.props, this.colDef.selectOptions);
      }

      if (this.colDef.indexedSelectOptions) {
        return this.colDef.selectOptions.map(function (option, index) {
          return {
            label: "".concat(index + 1, " - ").concat(typeof option === 'string' ? option : option.label),
            value: typeof option === 'string' ? option : option.value
          };
        });
      }

      return this.colDef.selectOptions;
    }
  }]);

  return SelectEditor;
}(CellEditor);

export { SelectEditor as default };